import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center h-full"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-xl font-bold text-gray-900 px-1 mb-4" }
const _hoisted_4 = { class: "text-gray-600 mb-4 text-center" }
const _hoisted_5 = {
  style: {"width":"20px"},
  class: "flex items-center"
}
const _hoisted_6 = ["onDragstart", "onDrop"]
const _hoisted_7 = { class: "self-end mb-2 cursor-move" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "text-red-900 text-right text-sm"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col w-full p-6 lg:w-2/3 bg-white border border-gray-200 shadow sm:rounded-lg"
}

import { Bars3Icon } from "@heroicons/vue/24/solid";
import { Stream } from "@oculai/planner";
import { Form, SubmissionHandler } from "vee-validate";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { onBeforeRouteUpdate } from "vue-router";
import * as yup from "yup";
import { StringSchema } from "yup";
import Field from "@/components/forms/Field.vue";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import { useStreams, useUpdateStreams } from "@/composables/stream";
import { useSaveBeforeLeaveConfirmationModal } from "@/composables/toast";

const maxCharacterCount = 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'TabCameras',
  setup(__props) {

const { t } = useI18n();

const { streams, isLoading } = useStreams();
const { updateStreams, isUpdateError } = useUpdateStreams();
const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();

const formRef = ref<typeof Form | null>(null);

onBeforeRouteUpdate((to, from, next) => {
  const meta = formRef.value?.meta;

  if (!meta?.dirty) {
    return next();
  }
  showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
    if (confirmed) {
      next();
    }
  });
});

const schema = computed(() =>
  yup.object({
    ...streams.value.reduce((acc, stream) => {
      acc[`name_${stream._id}`] = yup
        .string()
        .required(t("admin.cameras_project_settings.validation_name_required"))
        .max(
          maxCharacterCount,
          t("admin.cameras_project_settings.validation_max_characters", { maxCharacterCount }),
        );
      return acc;
    }, {} as Record<string, StringSchema>),
  }),
);

const initialValues = computed(() => {
  return {
    ...streams.value.reduce((acc, stream) => {
      acc[`name_${stream._id}`] = stream.name;
      return acc;
    }, {} as Record<string, string>),
    order: streams.value.map((stream) => stream._id),
  };
});

const handleDragStart = (event: DragEvent, streamId: string) => {
  if (event.dataTransfer) {
    event.dataTransfer.setData("text/plain", streamId);
    event.dataTransfer.effectAllowed = "move";
  }
};

const handleDrop = (
  e: DragEvent,
  toStreamId: string,
  order: string[],
  setFieldValue: (field: string, value: string[]) => void,
) => {
  e.preventDefault();
  if (e.dataTransfer) {
    const fromStreamId = e.dataTransfer.getData("text/plain");
    const fromStreamIndex = order.findIndex((_id) => _id === fromStreamId);
    const toStreamIndex = order.findIndex((_id) => _id === toStreamId);
    const newOrder = order.slice();
    newOrder.splice(fromStreamIndex, 1);
    newOrder.splice(toStreamIndex, 0, fromStreamId);
    setFieldValue("order", newOrder);
  }
};

const handleSubmit: SubmissionHandler = (genericObject, { resetForm }) => {
  const streams = genericObject.order.map((_id: string) => ({
    _id,
    name: genericObject[`name_${_id}`],
  }));
  return updateStreams(streams)
    .then(() => resetForm({ values: initialValues.value }))
    .catch(() => {
      // have to catch the error here, otherwise it's propagated as an unhandled error
      return undefined;
    });
};

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("admin.project_settings.tab_cameras")), 1),
        (_unref(streams).length > 0)
          ? (_openBlock(), _createBlock(_unref(Form), {
              key: 0,
              onSubmit: handleSubmit,
              initialValues: initialValues.value,
              validationSchema: schema.value,
              class: "flex flex-col w-full sm:p-6 p-3 2xl:w-2/3 settingsCard",
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(({ isSubmitting, values, setFieldValue, meta }) => [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("admin.cameras_project_settings.subheader")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.order
          .map((_id) => _unref(streams).find((item) => item._id === _id))
          .filter((item) => item), (stream, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stream._id,
                    class: "flex flex-col sm:flex-row gap-2 my-2 sm:my-0"
                  }, [
                    _createElementVNode("div", _hoisted_5, "#" + _toDisplayString(index + 1), 1),
                    _createElementVNode("div", {
                      draggable: true,
                      onDragstart: ($event: any) => (handleDragStart($event, stream._id)),
                      onDrop: ($event: any) => (handleDrop($event, stream._id, values.order, setFieldValue)),
                      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                      class: _normalizeClass(["flex flex-1 gap-2 p-4 border-b border-l border-r border-t sm:not-first:border-t-0", 
            index === 0
              ? ['border-t rounded-t']
              : [index === values.order.length - 1 ? 'rounded-b' : '']
          ])
                    }, [
                      _createVNode(Field, {
                        name: `name_${stream._id}`,
                        label: _unref(t)('admin.cameras_project_settings.field_name_label'),
                        class: "flex-1"
                      }, null, 8, ["name", "label"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(Bars3Icon), { class: "w-5 h-5" })
                      ])
                    ], 42, _hoisted_6)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: isSubmitting || !meta.dirty,
                  class: "flex items-center gap-2 rounded-md self-end w-min bg-yellow-600 px-3 py-2 mt-4 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600 disabled:bg-gray-300 disabled:cursor-default"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("buttons.save")), 1),
                  (isSubmitting && meta.valid)
                    ? (_openBlock(), _createBlock(LoadingSpinner, {
                        key: 0,
                        size: "w-4 h-4"
                      }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_8),
                (_unref(isUpdateError))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("admin.cameras_project_settings.save_error_message")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["initialValues", "validationSchema"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)("admin.cameras_project_settings.no_cameras_message")), 1))
      ]))
}
}

})